import axios from 'axios';

export const marketsRequest = () => axios.get(`/v1/markets`);
